import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AbstractAppConfigService, APP_CONFIG_SERVICE } from '@boxx/core/lib/contracts/IAppConfigService';
import { JsonApiResponse } from '@boxx/core/lib/contracts/IHttpBasicResponse';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  private businessSubject = new BehaviorSubject<any>(null);
  business$ = this.businessSubject.asObservable();
  
  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) { }

  getBusinessData() {
    return this.httpClient.get<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/business/get`
    );
  }

  getEventHistoryTypesData() {
    return this.httpClient.get<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/contact/events`
    );
  }

  setBusinessData(data: any): void {
    this.businessSubject.next(data);
  }

  getBusinessInfo(): any {
    return this.businessSubject.getValue();
  }

  verifySubscriptionStatus(brand_id: any, subscription_id: any): any {
    return this.httpClient.get<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/chargebee/verifySubscriptionStatus/${brand_id}/${subscription_id}`,
    );
  }

  getColorThemes(): any {
    return this.httpClient.get<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/wizard/get_color_themes`,
    );
  }

  private getJsonBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/json/v1`;
  }

}